import { useNavigate, useLocation } from 'react-router-dom';
import { ClipboardCheck, History, LogOut } from 'lucide-react';
import { clearAuth } from '../lib/auth';
import { toast } from 'sonner';

const COMPANY_LOGO = 'https://customer-assets.emergentagent.com/job_coachcheck/artifacts/w12hb0ce_Screenshot_20260118_231725_Samsung%20Internet.jpg';

export default function DriverLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    clearAuth();
    toast.success('Logged out successfully');
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-blue-900 text-white py-3 px-4 sticky top-0 z-40">
        <div className="max-w-2xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src={COMPANY_LOGO} 
              alt="City Cabs" 
              className="h-10 w-10 rounded-lg object-cover bg-white"
            />
            <div>
              <h1 className="font-bold text-base leading-tight">City Cabs</h1>
              <p className="text-blue-200 text-xs">Vehicle Checks</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="p-2 hover:bg-blue-800 rounded-lg transition-colors"
            data-testid="logout-btn"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-2xl mx-auto p-4">
        {children}
      </main>

      {/* Bottom Navigation */}
      <nav className="mobile-nav" data-testid="driver-nav">
        <button
          className={`mobile-nav-item ${isActive('/driver/checklist') ? 'active' : ''}`}
          onClick={() => navigate('/driver/checklist')}
          data-testid="nav-checklist"
        >
          <ClipboardCheck />
          <span>Checklist</span>
        </button>
        <button
          className={`mobile-nav-item ${isActive('/driver/history') ? 'active' : ''}`}
          onClick={() => navigate('/driver/history')}
          data-testid="nav-history"
        >
          <History />
          <span>History</span>
        </button>
      </nav>
    </div>
  );
}
